export default __webpack_public_path__ + "static/media/Buildings_DSC_0496.f5937918.JPG";